import PricingStatusCard from './PricingStatusCard';

export default PricingStatusCard;
